import { CatchPraise } from "@/components/catchPraise";
import { useGetCommon, type RoomPreviewInfoResponse } from "@/shared/server";
import { MEDIA } from "@/styles/common";
import { Center, Flex, Spinner } from "@chakra-ui/react";
import { useNewNavigate } from "@shared/client";
import { Carousel } from "react-responsive-carousel";
import { CustomButton, CustomCenter } from "./roomPreview.style";

export const RoomPreview = () => {
    const { data } = useGetCommon<RoomPreviewInfoResponse>({ section: "rooms" });
    const { onNavigate } = useNewNavigate();
    const { isMobile } = MEDIA();

    return data ? (
        <CustomCenter
            boxSizing="border-box"
            overflow="hidden"
            w="100%"
            sx={{
                ".carousel .control-dots .dot": isMobile
                    ? {
                          width: "12px !important",
                          height: "12px !important",
                      }
                    : {},
            }}
        >
            <Carousel
                infiniteLoop
                autoPlay
                interval={3000}
                showThumbs={false}
                showArrows={false}
                showStatus={false}
                emulateTouch
                preventMovementUntilSwipeScrollTolerance
                swipeScrollTolerance={100}
            >
                {data.currentRooms.map((currentRoom) => {
                    const catchPraise = {
                        main: {
                            firstLine: currentRoom.roomDetailInfo.name,
                        },
                        sub: {
                            firstLine: currentRoom.roomDetailInfo.structure,
                        },
                    };

                    return (
                        <Center
                            h={isMobile ? "640px" : "824px"}
                            boxSizing="border-box"
                            overflow="hidden"
                            key={currentRoom.roomIdx}
                            background={`url(${currentRoom.imgUrl}) no-repeat center/cover`}
                        >
                            <Flex
                                w="100%"
                                p="32px"
                                boxSizing="border-box"
                                flexDir="column"
                                alignItems="flex-start"
                                rowGap="60px"
                                background="rgba(0,0,0,0.25)"
                                color="white"
                            >
                                <CatchPraise annotation="Rooms" catchPraise={catchPraise} isDetail={false} />
                                <CustomButton
                                    size="tiny"
                                    round="pill"
                                    border="none"
                                    iconNamed="add"
                                    onClick={() => onNavigate({ path: `/rooms/${currentRoom.roomIdx}` })}
                                >
                                    View More
                                </CustomButton>
                            </Flex>
                        </Center>
                    );
                })}
            </Carousel>
        </CustomCenter>
    ) : (
        <Spinner />
    );
};
